import React from 'react';
import * as S from './pix-upsell-modal.style';
import { Sell } from '../../../common/types/venda';

type Props = {
  open: boolean;
  sell: Sell | null;
  onClose: () => void;
};

export const PixUpsellModal: React.FC<Props> = ({ open, sell, onClose }) => {
  if (!open || !sell) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(sell.pixCopiaCola);
    } catch (e) {
      console.error('Erro ao copiar código Pix', e);
    }
  };

  return (
    <S.Overlay>
      <S.Modal>
        <S.Header>
          <h3>Oferta ativada via Pix</h3>
          <button type="button" onClick={onClose}>
            ✕
          </button>
        </S.Header>

        <S.Body>
          {sell.pixQrCode && (
            <S.QRWrapper>
              <img src={`data:image/png;base64, ${sell?.pixQrCode}`} alt="QR Code Pix" />
            </S.QRWrapper>
          )}

          <S.Instruction>
            Escaneie o QR Code ou copie o código Pix abaixo para concluir o
            pagamento da oferta extra.
          </S.Instruction>

          <S.CodeBox>
            <textarea
              readOnly
              value={sell.pixCopiaCola}
              onFocus={(e) => e.currentTarget.select()}
            />
          </S.CodeBox>

          <S.CopyButton type="button" onClick={handleCopy}>
            Copiar código Pix
          </S.CopyButton>
        </S.Body>
      </S.Modal>
    </S.Overlay>
  );
};
